import { Action, initialState, State } from 'store/store';
import {
  getAllTopicsOrdered,
  getInteractionsFromTopicAndState,
} from 'selectors/block';
import { Block } from '@chameleoncreator/creator-app';

export const preprocessModule = (
  state: State = initialState,
  { data }: Action
): State => {
  const topics = getAllTopicsOrdered(state.blocks);
  const nextInteractionMap = {};
  const idToSIdMap = {};
  const sIdToIdMap = {};

  let interactionsLocked: string[] = [];
  // *
  // when we're wanting to test this locally we need to include this line
  // since there's different timings to when savedState loads from scorm/localStorage
  // state.interactionsLocked || [];

  topics.forEach(topic => {
    const interactions = getInteractionsFromTopicAndState(
      state as any,
      (Object.values(state.blocks) as any).find(($: any) => $.id === topic.id)
    );

    interactions.forEach((interaction, index) => {
      const { id } = interaction;
      const { sId, lockDown } = (interaction as any)?.props;

      // *
      // if (!interactionsLocked.length) {
      // }

      if (lockDown) {
        interactionsLocked.push(id);
      }

      idToSIdMap[id] = sId;
      sIdToIdMap[sId] = id;

      if (index != interactions.length - 1) {
        nextInteractionMap[id] = interactions[index + 1].id;
      }
    });
  });

  return {
    ...state,
    ...data,
    interactionsLocked,
    ...{ nextInteractionMap },
    ...{ idToSIdMap },
    ...{ sIdToIdMap },
  };
};
